"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _default = function _default(_ref) {
  var filename = _ref.filename;
  return _react.default.createElement("div", {
    className: "m-bottom-2"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "FileManagerLib.notifications.upload.expectedImage.message",
    options: {
      filename: filename
    }
  }));
};

exports.default = _default;
module.exports = exports.default;